export default __webpack_public_path__ + "24e2b8f21013933820857f1617661728.png";